import { breakpointSizes, Button } from "@brightagency/headstart-common";
import React from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import styled from "styled-components";
import { useAssessmentState } from "../../../../services/assessment-state";
import { Screens } from "../../../../services/assessment-state/types";
import { buttonResetStyles } from "../../../../utils";
import { areLocalDevFeaturesEnabled } from "../../../../utils/basic-only";
import { FadeSwitchAnimation, ButtonWidthManager } from "./styled";

const Outer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 48px;
    width: 100%;
`;

const BackButton = styled.button`
    ${buttonResetStyles};
    text-align: center;
    color: white;
    font-size: 85%;

    &:hover {
        text-decoration: underline;
    }
`;

export const NavigationButtons: React.FC<{
    isEnabled: boolean;
    isSkippable: boolean;
}> = props => {
    const { state, setState, goNext, goToScreen, skip } = useAssessmentState();
    const handleclick = () => {
        setState({
            showselection:0,
        });
        goNext();
    };

    return (
        <Outer>
            <ButtonWidthManager>
                { 
                    (state.currentScreen == 1) ? 
                        <Button
                        maxWidth={-1}
                        disabled={!props.isEnabled}
                        appearance="secondary"
                        onClick={handleclick}
                        >
                            Set suburb
                        </Button>
                    : 
                        <Button
                        maxWidth={-1}
                        disabled={!props.isEnabled}
                        appearance="secondary"
                        onClick={goNext}
                        >
                            Next
                        </Button>
                }
                
                {props.isSkippable && (
                    <BackButton onClick={skip} style={{ marginTop: 24 }}>
                        None of the above/prefer not to say
                    </BackButton>
                )}
                {areLocalDevFeaturesEnabled() && (
                    <BackButton
                        onClick={() => goToScreen(Screens.Results)}
                        style={{ marginTop: 24 }}
                    >
                        Skip to end
                    </BackButton>
                )}
            </ButtonWidthManager>
        </Outer>
    );
};

export const FadeSwitchAnimationWrapper: React.FC<{
    changeKey: string | number;
    duration?: number;
    delay?: number;
}> = props => {
    const { duration = 200, delay = 0 } = props;
    return (
        <SwitchTransition>
            <CSSTransition
                classNames="fade-switch"
                timeout={duration + delay}
                key={props.changeKey}
            >
                <FadeSwitchAnimation duration={duration} delay={delay}>
                    {props.children}
                </FadeSwitchAnimation>
            </CSSTransition>
        </SwitchTransition>
    );
};

export * from "./styled";

export const gridBreakpoints = [
    { breakpointWidth: 0, columns: 1, gutter: 30 },
    { breakpointWidth: breakpointSizes.medium, columns: 2, gutter: 50 },
    { breakpointWidth: breakpointSizes.large, columns: 3, gutter: 50 },
];
